// Ephemeral "mini" node that is only visible on method drag
export interface MethodBeingDraggedNode {
  id: string;
  name: string;
  position: {x: number; y: number};
}

interface BaseMethodDropZone {
  position: {x: number; y: number};
  width: number;
  height: number;
}

export enum DropZoneType {
  METHOD_EDGE,
  METHOD_ROOT,
  METHOD_LEAF,
}

export interface MethodEdgeDropZone extends BaseMethodDropZone {
  type: DropZoneType.METHOD_EDGE;
  edgeId: string;
  fromMethod: string;
  toMethod: string;
}

export interface MethodRootDropZone extends BaseMethodDropZone {
  type: DropZoneType.METHOD_ROOT;
  prependToMethodCid: string;
}

export interface MethodLeafDropZone extends BaseMethodDropZone {
  type: DropZoneType.METHOD_LEAF;
  appendFromMethodCid: string;
}

export type MethodDropZone = MethodEdgeDropZone | MethodRootDropZone | MethodLeafDropZone;
